import osParsersList from './osList';
import array from '@/common/array';
/**
 * The main class that arranges the whole parsing process.
 */
class Parser {
    constructor(UA) {
        if (!UA) {
            throw new Error("UserAgent parameter can't be empty");
        }
        this._ua = UA;
        /**
         * @property {Object} os
         * @property {String|undefined} [os.name] OS name, like `"Windows"` or `"macOS"`
         * @property {String|undefined} [os.version] OS version, like `"NT 5.1"` or `"10.11.1"`
         * @property {String|undefined} [os.versionName] OS name, like `"XP"` or `"High Sierra"`
         */
        // @ts-ignore
        this.parsedResult = {};
        this.parseOS();
    }
    /**
     * Get UserAgent string of current Parser instance
     * @return {String} User-Agent String of the current <Parser> object
     *
     * @public
     */
    getUA() {
        return this._ua;
    }
    /**
     * Test a UA string for a regexp
     * @param {RegExp} regex
     * @return {Boolean}
     */
    test(regex) {
        return regex.test(this._ua);
    }
    /**
     * Get OS
     * @return {Object}
     *
     * @example
     * this.getOS();
     * {
     *   name: 'macOS',
     *   version: '10.11.12'
     * }
     */
    getOS() {
        if (this.parsedResult.os) {
            return this.parsedResult.os;
        }
        return this.parseOS();
    }
    /**
     * Parse OS and save it to this.parsedResult.os
     * @return {*|{}}
     */
    parseOS() {
        // @ts-ignore
        this.parsedResult.os = {};
        const os = array.find(osParsersList, (_os) => {
            if (typeof _os.test === 'function') {
                return _os.test(this);
            }
            if (_os.test instanceof Array) {
                return _os.test.some((condition) => this.test(condition));
            }
            throw new Error("Browser's test function is not valid");
        });
        if (os) {
            this.parsedResult.os = os.describe(this.getUA());
        }
        return this.parsedResult.os;
    }
    /**
     * Get OS name
     * @param {Boolean} [toLowerCase] return lower-cased value
     * @return {String} name of the OS — macOS, Windows, Linux, etc.
     */
    getOSName(toLowerCase) {
        const { name } = this.getOS();
        if (toLowerCase) {
            return String(name).toLowerCase() || '';
        }
        return name || '';
    }
    /**
     * Get OS version
     * @return {String} full version with dots ('10.11.12', '5.6', etc)
     */
    getOSVersion() {
        return this.getOS().version;
    }
}
export default Parser;
